<template>
  <component :is="loginComponent" />
</template>

<script setup>
import { computed } from 'vue';
import { useContextStore } from '@/stores/context';

const context = useContextStore();

const loginComponent = computed(() => {
  let component = 'LoginHardcoded';
  if (context.loginMethod === 'auth-saml') component = 'LoginSAML';
  // this is a page, as it's also injected via router on /ow-auth/login
  if (context.loginMethod === 'ow-auth-okta') component = 'LoginPageOkta';
  if (context.loginMethod === 'auth-openid') component = 'LoginPageOpenID';
  return component;
});
</script>
